import React from 'react'

import Paper from '@mui/material/Paper'

export default function PaperCard ({ children, className }) {
  return (
    <Paper
      className={className}
      elevation={3}
      sx={{
        borderRadius: '15px',
        height: '580px',
        overflowY: 'auto',
        padding: '25px',
        position: 'relative'
      }}
    >
      <div>{children}</div>
    </Paper>
  )
}
